import React from 'react';
import ImportsBase from './ImportsBase';
import Card from '../../components/Card';
import ImportDadosPessoaisColumnRules from '../../components/imports/ImportDadosPessoaisColumnRules';
import ImportPlanosFinanceirosColumnsRules from '../../components/imports/ImportPlanosFinanceirosColumnRules';
import ImportOnboardingColumnRules from '../../components/imports/ImportOnboardingColumnRules';
import ImportInviteColumnRules from '../../components/imports/ImportInviteColumnRules';
import ImportContractModelColumnRules from '../../components/imports/ImportContractModelColumnRules';


class ImportsPage extends React.Component {
  get data() {
    return [
      {
        id: 1,
        endpoint: '/personal/import-personal-data',
        title: 'Dados pessoais',
        ruleset: <ImportDadosPessoaisColumnRules />,
      },
      {
        id: 2,
        endpoint: '/finance/import-finance-plans',
        title: 'Planos Financeiros',
        ruleset: <ImportPlanosFinanceirosColumnsRules />,
      },
      {
        id: 3,
        endpoint: '/onboarding/import-onboarding',
        title: 'Processo de Matricula',
        ruleset: <ImportOnboardingColumnRules />,
      },
      {
        id: 4,
        endpoint: '/import-invite-process',
        title: 'Processo de convocação de matrícula',
        ruleset: <ImportInviteColumnRules />,
      },
      {
        id: 5,
        endpoint: '/contracts/import-contract-model',
        title: 'Modelo de contrato',
        ruleset: <ImportContractModelColumnRules />,
      },
      // {
      //   id: 6,
      //   endpoint: '/onboarding/import-finance-plan',
      //   title: 'Plano financeiro',
      //   ruleset: <ImportFinancePlanColumnRules />,
      // },
    ];
  }
  
  render() {
    return (
      <Card title="Importação de dados">
        <ImportsBase data={this.data} />
      </Card>
    );
  }
}

export default ImportsPage;
